

































































import { Component, Vue } from "vue-property-decorator";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import SelectOption from "@/components/common/SelectOption";
import { TaxEventReconciliationStatus } from "@/dto/tax/TaxEventDTO";
import TaxEventReconciliationPayload from "@/dto/tax/TaxEventReconciliationPayload";
import TaxEventService from "@/services/TaxEventService";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import moment from "moment";

@Component({
  components: {
    PortalInput,
    PortalSelect,
    PortalTextarea,
    SingleFileHolder
  }
})
export default class AddReconciliationRecordModal extends Vue {
  private taxEventId: number | null = null;
  private agencyBalanceLocal: number | string = "";
  private form: Partial<TaxEventReconciliationPayload> = {
    verificationDate: moment().format("YYYY-MM-DD"),
    reconciliationStatus: TaxEventReconciliationStatus.MATCHED,
    comment: "",
    document: null
  };

  get statusOptions() {
    return Object.values(TaxEventReconciliationStatus).map(val => 
      SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build()
    );
  }

  beforeOpen(event: any) {
    this.taxEventId = event.params.taxEventId;
    this.agencyBalanceLocal = "";
    this.form = {
      verificationDate: moment().format("YYYY-MM-DD"),
      reconciliationStatus: TaxEventReconciliationStatus.MATCHED,
      comment: "",
      document: null
    };
    this.$validator.reset();
  }

  closeModal() {
    this.$modal.hide("add-reconciliation-record-modal");
  }

  get isValid(): boolean {
    return !!(this.form.verificationDate && this.agencyBalanceLocal !== "" && this.form.reconciliationStatus);
  }

  async submit() {
    const valid = await this.$validator.validateAll();
    if (!valid || !this.taxEventId) return;

    const payload: TaxEventReconciliationPayload = {
      agencyBalanceCents: Math.round(parseFloat(this.agencyBalanceLocal.toString()) * 100),
      verificationDate: this.form.verificationDate!,
      reconciliationStatus: this.form.reconciliationStatus!,
      comment: this.form.comment || null,
      document: this.form.document || null
    };

    Application.startLoading();
    TaxEventService.addReconciliationRecord(this.taxEventId, payload).then(
      () => {
        Application.stopLoading();
        this.$emit("added");
        this.closeModal();
      },
      err => {
        Application.stopLoading();
        processError(err, this);
      }
    );
  }
}
